import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=0b9e94da&scoped=true"
import script from "./ChangeStatus.vue?vue&type=script&lang=js"
export * from "./ChangeStatus.vue?vue&type=script&lang=js"
import style0 from "./ChangeStatus.vue?vue&type=style&index=0&id=0b9e94da&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e94da",
  null
  
)

export default component.exports